import { useContext, useMemo } from "react"

import {
  resetDepositState,
  selectDepositFromAnotherWallet,
  selectDepositModalClosed,
  selectDepositStatus,
  useDappDispatch,
  useDappSelector,
} from "#/redux-state"
import { IS_MEZO_MAINNET, routes } from "#/shared/constants"
import { FlowContext } from "#/shared/context"
import { useEffectOnce, useStatistics, useTabsNavigation } from "#/shared/hooks"
import { DepositPageTab } from "#/shared/types"
import DepositFormContainer from "#/ui-old/Deposit/DepositFormContainer"

import { Tabs } from "../Tabs"

import DepositCompleted from "./DepositCompleted"
import DepositListDashboard from "./DepositListDashboard"

export default function DepositDashboard() {
  const { activeTab, onChangeTab } = useTabsNavigation<DepositPageTab>(
    DepositPageTab.MANAGE,
    routes.DEPOSIT,
  )

  const depositStatus = useDappSelector(selectDepositStatus)
  const depositModalClosed = useDappSelector(selectDepositModalClosed)

  const depositFromAnotherWallet = useDappSelector(
    selectDepositFromAnotherWallet,
  )

  const dispatch = useDappDispatch()

  const { isBitcoinFlow, flow } = useContext(FlowContext)

  useEffectOnce(() => {
    dispatch(resetDepositState({ flow }))
  })

  useStatistics()

  const showCompletedScreen = useMemo(
    () =>
      isBitcoinFlow || depositFromAnotherWallet
        ? depositStatus === "completed" && depositModalClosed
        : depositStatus === "completed",
    [
      depositStatus,
      depositModalClosed,
      isBitcoinFlow,
      depositFromAnotherWallet,
    ],
  )

  const tabsItems = useMemo(
    () => [
      {
        key: DepositPageTab.MANAGE,
        title: "Manage",
        children: <DepositListDashboard onChangeTab={onChangeTab} />,
      },
      {
        key: DepositPageTab.NEW_DEPOSIT,
        title: "New deposit",
        children: showCompletedScreen ? (
          <DepositCompleted setActiveTab={onChangeTab} />
        ) : (
          <DepositFormContainer />
        ),
      },
    ],
    [onChangeTab, showCompletedScreen],
  )

  return IS_MEZO_MAINNET ? (
    <DepositListDashboard onChangeTab={onChangeTab} />
  ) : (
    <Tabs onChange={onChangeTab} activeKey={activeTab} tabs={tabsItems} />
  )
}
